const sha256 = require("sha256")

export class User {
    private username: string;
    private serverChannel: ServerChannel;

    constructor(username: string) {
        this.username = username;
        this.serverChannel = new ServerChannel(username)
    }

    /**
     * returns the username of the current user
     */
    public getUsername(): string {
        return this.username;
    }

    public requestSomething(foo: any): any {
        //TODO: sample function, implement real stuff
        return this.serverChannel.requestSomething(foo)
    }

    public sendSomething(foo: any): boolean {
        //TODO: sample function, implement real stuff
        return this.serverChannel.sendSomething(foo);
    }

}

/**
 * Idea of this class is to form an abstraction of a secure channel to a part of the server. Such a channel
 * shall uniquely identify a user
 */
class ServerChannel {
    public static readonly SERVER_ADDRESS: string = "https://xlogo.inf.ethz.ch/foo/"
    private serverBase: string;
    constructor(serverBase: string) {
        this.serverBase = serverBase;
    }

    public requestSomething(foo: any): any {
        //TODO: sample function, implement real stuff
        return null;
    }

    public sendSomething(something: any): boolean {
        //TODO: sample function, implement real stuff
        return true;
    }
}

class ServerRequest {
    //The user issuing the request
    public user: User;

    //An optional error message
    public errorString: string;

    //The return codes of the server protocols and their ids. Ids are used for the languageservice
    public static readonly SUCCESS_CODE: number = 0
    public static readonly SUCCESS_ID: string = "serversuccess"
    public static readonly UNKNOWN_USER_CODE: number = 1
    public static readonly UNKNOWN_USER_ID: string = "unknownuser"
    public static readonly WRONG_PASSWORD_CODE: number = 2
    public static readonly WRONG_PASSWORD_ID: string = "wrongpassword"
    public static readonly USERNAME_ALREADY_TAKEN_CODE: number = 3
    public static readonly USERNAME_ALREADY_TAKEN_ID: string = "usernamealreadytaken"

    /**
     * returns true iff the @param response indicates success
     * @param response 
     */
    protected static checkServerResponse(response: string): boolean {
        return Number(response.split(":")[1].split("\n")[0]) === ServerRequest.SUCCESS_CODE;
    }

    /**
     * Based on @param response by the server and the http @param status, determine an return an erroridentifier
     * @param response 
     * @param status 
     */
    protected static parseErrorMessage(response: string, status: number): string {
        if (status >= 200 && status < 300) {
            var code: number = Number(response.split(":")[1].split("\n")[0])
            switch (code) {
                case ServerRequest.UNKNOWN_USER_CODE: return ServerRequest.UNKNOWN_USER_ID;
                case ServerRequest.WRONG_PASSWORD_CODE: return ServerRequest.WRONG_PASSWORD_ID;
                case ServerRequest.USERNAME_ALREADY_TAKEN_CODE: return ServerRequest.USERNAME_ALREADY_TAKEN_ID;
                default: return "undefined";
            }
        }
        switch (status) {
            //TODO: implement identifiers for common http errors, s.t. LoginService can provide appropriate error messages
            default: return "undefined"
        }
    }
}

export class LoginRequest extends ServerRequest {
    private username: string = null;
    private password: string = null;
    private type: string = null;
    private static readonly LOGIN_SERVER_ADDRESS: string = ServerChannel.SERVER_ADDRESS + "login"

    /**
     * Attempt to login usign:
     * @param username 
     * @param password 
     * @param newUser indicates whether to perform a registration or a login request
     */
    public static async performLoginRequest(username: string, password: string, newUser: boolean): Promise<LoginRequest> {
        //build message
        var loginRequest: LoginRequest = new LoginRequest();
        loginRequest.username = username;
        loginRequest.password = sha256.x2(password);
        loginRequest.type = newUser ? "Register" : "Login";

        //open channel to server
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.open("POST", LoginRequest.LOGIN_SERVER_ADDRESS, true);
        xmlhttp.setRequestHeader("Content-Type", "application/json");

        //send message
        xmlhttp.send(JSON.stringify({ username: loginRequest.username, password: loginRequest.password, typeoflogin: loginRequest.type }));

        var promise = new Promise<LoginRequest>((resolve, reject) => {
            xmlhttp.onload = function () {
                if (xmlhttp.status >= 200 && xmlhttp.status < 300 && LoginRequest.checkServerResponse(xmlhttp.response)) {
                    //everything fine, set user and return request
                    loginRequest.user = new User(username);
                    resolve(loginRequest);
                    return username;
                } else {
                    //something wrong. set user and return request
                    loginRequest.errorString = LoginRequest.parseErrorMessage(xmlhttp.response, xmlhttp.status)
                    reject(loginRequest);
                    return username;
                }
            }.bind(this);
            return null;
        })
        return promise;
    }
}




// WEBPACK FOOTER //
// ./src/app/lib/LoginUtilities.ts